var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"technologyDivParent"},[_c('title-widge',{attrs:{"title":_vm.title,"subTitle":_vm.subTitle}}),_c('div',{staticClass:"divImg"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({
      src:_vm.bgUrl,
      loading: require('./../../../../../assets/wheelplanting.jpg')
    }),expression:"{\n      src:bgUrl,\n      loading: require('./../../../../../assets/wheelplanting.jpg')\n    }"}]}),_c('ul',_vm._l((_vm.details),function(item){return _c('li',{key:item},[_c('em'),_c('span',[_vm._v(_vm._s(item))])])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }